// extracted by mini-css-extract-plugin
export var contrastLow = "_q-1";
export var externalLink = "_q-2";
export var externalLinkIcon = "_q-3";
export var link = "_q-0";
export var linkLabel = "_q-4";